export default __webpack_public_path__ + "static/media/TUNE_SNOW_120X278_03_265.3535076c.jpg";